<template>
  <div>
    <div v-html="stats" />
    <vxe-grid
      resizable
      :data="list"
      :columns="columns" />
  </div>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'ServiceApi',
  mixins: [WindowsMixin, ListMixin],
  props: {
    getParams: {
      type: Object,
    },
    data: {
      type: Object,
      required: true,
    },
    cloudEnv: String,
  },
  data () {
    return {
      list: [],
      columns: [
        {
          field: 'name',
          title: this.$t('table.title.name'),
          sortable: true,
        },
        {
          field: 'method',
          title: 'method',
          sortable: true,
        },
        {
          field: 'path',
          title: 'path',
          sortable: true,
        },
        {
          field: 'hit.2XX',
          title: 'hit.2XX',
          sortable: true,
        },
        {
          field: 'duration.2XX',
          title: 'duration.2XX',
          sortable: true,
        },
        {
          field: 'hit.4XX',
          title: 'hit.4XX',
          sortable: true,
        },
        {
          field: 'duration.4XX',
          title: 'duration.4XX',
        },
        {
          field: 'hit.5XX',
          title: 'hit.5XX',
        },
        {
          field: 'duration.5XX',
          title: 'duration.5XX',
          sortable: true,
        },
      ],
      stats: '',
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        let response
        if (this.cloudEnv === 'host') {
          response = await new this.$Manager(`hosts/${this.data.id}/api-stats`, 'v1').list()
        } else {
          response = await new this.$Manager('stats/api_stats', 'v1').list({
            params: {
              service: this.data.type,
            },
          })
        }
        this.list = response.data?.paths || []
        const keys = Object.keys(response.data)
        this.stats = keys.filter(key => key !== 'paths').map(key => {
          return `<span style="color: var(--antd-wave-shadow-color)">${key}</span>: <span class="mr-2">${response.data[key] || 0}</span>`
        }).join(' ')
      } catch (error) {
        this.$Message.error(error.message)
      }
    },
  },
}
</script>
